<template>
  <nav aria-label="Pagination">
    <ul class="menu pagination align-center">
      <li 
        v-for="n in total"
        :key="n" 
        :class="{ 'menu-text': n == currPage }">
        <span v-if="n == currPage">
          <strong>{{ n }}</strong>
        </span>
        <a v-else @click.prevent="$emit('to-page', n)" href="#">{{ n }}</a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default { 
  name: 'Pagination',
  props: {
    currPage: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
}
</script>
